<style scoped>
.section-items h4 {
  line-height: 20px;
}
</style>
<template>
  <layout name="LayoutDefault">
    <div class="Authors">
      <!-- Page Content -->
      <div class="container contents">
        <!-- Page Features -->
        <div class="pt-0 pt-md-3">
          <div class="row">
            <div
              v-for="(item, k) in categories"
              :key="k"
              class="col-lg-2 col-sm-4 col-6"
            >
              <div class="category-item">
                <a
                  :href="`${baseUrl}category/${item.id}/newest`"
                  v-bind:style="{
                    'background-image': 'url(' + categoryBg(item) + ')'
                  }"
                >
                  <h4 class="ct-name">{{ item.category_name }}</h4>
                </a>
              </div>
            </div>
          </div>

          <nav class="d-flex justify-content-center">
            <ul class="pagination">
              <li
                v-for="(item, k) in links"
                :key="k"
                :class="getPagingClass(item)"
              >
                <a
                  class="page-link"
                  @click="getCategories(item.url)"
                  href="javascript:;"
                  v-html="getPagingLabel(item)"
                ></a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
    <!-- /.container -->
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";

export default {
  data() {
    return {
      loading: true,
      categories: true,
      links: null
    };
  },
  components: {
    Layout
  },
  methods: {
    categoryBg(item) {
      if (item.image) {
        return this.IMAGEURL + "/category/" + item.image;
      } else {
        return "/assets/img/placeholder/category.png";
      }
    },
    getPagingLabel(item) {
      let string = item.label;
      string = string.replace("Next", "");
      string = string.replace("Previous", "");
      return string;
    },
    getPagingClass(item) {
      if (item.url && item.active === true) {
        return "page-item active";
      } else if (!item.url) {
        return "page-item disabled";
      } else {
        return "page-item";
      }
    },
    getCategories(url) {
      this.$http
        .get(url)
        .then(response => {
          this.categories = response.data.data;
          this.links = response.data.links;
          $(".back-to-top").trigger("click");
        })
        .catch(e => {
          this.categories = null;
          this.links = null;
        });
    }
  },
  mounted() {
    this.getCategories("category/all");
  }
};
</script>
